module.exports = __webpack_public_path__ + "img/162085.d9ac0bc8.jpg";